// ハンバーガーメニュー
jQuery(function () {
  // 開く
  jQuery('.menu-trigger').on('click', function () {
    jQuery(this).toggleClass('active');
    jQuery('.site-header').toggleClass('sp-menu-active');

    jQuery('.menu-global-sp').fadeToggle(300); //ふわっとだす
    return false;
  });
  jQuery('.menu-global-sp .menu-close').on('click', function () {
    jQuery('.menu-trigger').removeClass('active');
    jQuery('.menu-global-sp').fadeToggle(300); //ふわっとだす
  });
});
